import { render, staticRenderFns } from "./Assay.vue?vue&type=template&id=67668836&"
import script from "./Assay.vue?vue&type=script&lang=ts&"
export * from "./Assay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports